import { IPdfImages } from '../base';

/**
 * 图片加载队列
 */
export class ImageLoadQueue {
    static MAX_OF_PARALLEL_DOWNLOADS = 5; // 最大并行下载数
    path: string = '';
    list: string[] = [];
    loadedQueue: Set<string> = new Set();
    loadingQueue: Set<string> = new Set();

    constructor(data: IPdfImages = { path: '', list: [] }) {
        this.path = data.path; // 图片路径
        this.list = data.list; // 图片列表
    }

    preload(imageIndex: number) {
        const imageKey = this.list[imageIndex];
        imageIndex = Math.min(imageIndex, this.list.length - 1);
        if (this.loadedQueue.has(imageKey) || this.loadingQueue.has(imageKey)) {
            return;
        }
        this.loadingQueue.add(imageKey);
        const img = new Image();
        img.onload = () => {
            this.loadedQueue.add(imageKey);
            this.loadingQueue.delete(imageKey);
        };
        img.onerror = () => {
            this.loadingQueue.delete(imageKey);
        };
        img.src = this.path + this.list[imageIndex];
    }

    batchPreload(startIndex: number, count: number, dir: 'pre' | 'next') {
        let newlyAdd = 0;
        for (let index = startIndex; index < this.list.length; dir === 'next' ? index++ : index--) {
            if (this.loadedQueue.has(this.list[index])) {
                continue;
            }
            this.preload(index);
            newlyAdd++;
            if (count == newlyAdd) {
                break;
            }
        }
    }

    /**
     * 进入排队状态
     * @param startIndex
     */
    enqueue(startIndex: number, dir: 'pre' | 'next') {
        if (startIndex === this.list.length - 1) {
            return;
        }
        const count = ImageLoadQueue.MAX_OF_PARALLEL_DOWNLOADS - this.loadingQueue.size;
        if (count === 0) {
            return;
        }

        this.batchPreload(startIndex, count, dir);
    }
}
